/**
 * @generated SignedSource<<6c3a1fe962ffe6f8ea2962b6a5259e4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueSidebarSecondaryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DevelopmentSectionFragment" | "LinkedPullRequests" | "RelationsSectionFragment" | "SubscriptionSectionFragment">;
  readonly " $fragmentType": "IssueSidebarSecondaryQuery";
};
export type IssueSidebarSecondaryQuery$key = {
  readonly " $data"?: IssueSidebarSecondaryQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSidebarSecondaryQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueSidebarSecondaryQuery",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedPullRequests"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RelationsSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubscriptionSectionFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "51a78ac0ec1400d9c56110b7be810397";

export default node;
